import React from 'react';
import '../../styles/onboardingFlow/onboardingComponents/onboardingMobileLogoPanel.scss';
import adupLogoSet from '../../assets/onboarding/common/adup-logo-set.png';

const OnboardingMobileLogoPanel: React.FC = () => {
  return (
    <div className='onboardingMobileLogoPanel'>
      <img
        src={adupLogoSet}
        alt='TARA AdUp'
        className='onboardingMobileLogoPanel__logo'
      />
    </div>
  );
};

export default OnboardingMobileLogoPanel;
